import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.FundWalletPopupContent.FundWalletCard', {
    copy: 'Copy',
    copiedToClipboard: 'Copied to clipboard!',
});
